import MapSettings from "./map-settings";

export { parseCoordinateConversionRule } from "./map-settings";

export default MapSettings;
